<template>
    <div id="tabbifier-header" class="app-header row">
        <div v-for="item in config" class="col can-click" @click="$emit('input', item)" :class="{ active: item == value }"  :key="item">
            <h1>{{item}}</h1>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Tabbifier-header',
        props: {
            value: {
                type: [String, Number]
            },
            config: {
                type: [Array],
                default: []
            }
        },
    }
</script>

<style lang="less" scoped>
    @fontSize: 15px;
    .can-click {
        cursor: pointer;
        border-bottom: var(--ui-border);
        text-align: center;
        h1 {
            font-size: @fontSize;
            margin-bottom: @fontSize;
            text-transform: uppercase;
        }
        &.active {
            h1 {
                color: var(--primary);
            }
            border-bottom-color: var(--primary);
        }
    }
</style>